/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
enum StockCategory {
  classes = 'A',
  dna = 'B',
  cancel = 'B',
  consultancy = 'C',
  discount = 'D',
  stock = 'S',
  package = 'P',
  pathology = 'L'
}

export default StockCategory;
